import TabBar from './TabBar';
import TabBarItem from './TabBarItem';

export type { TabBarProps, TabBarCssVars } from './TabBar';
export type { TabBarItemProps } from './TabBarItem';

TabBar.Item = TabBarItem;

export default TabBar;
